import { useHistory } from 'react-router'
import { useState, useEffect, useContext } from 'react'
import { MainContainer, Space, Radio } from 'verak-ui'
import { Container } from 'react-bootstrap'
import { Context } from '../../context/Provider'
import { useFetch } from '../../api/apihook'

import { Header, CCTVWarning, inputStyle, AddressField, Label } from './Common'
import { radioOptionTextStyle } from '../DraftRFQ/DraftRFQForm'
import FormInput from '../../components/FormInput'

import cisImg from '../../assets/icons/cis.svg'

const CIS = () => {
	const history = useHistory()
	const [state, dispatch] = useContext(Context)
	let fetch = useFetch()
	const PolicyAddons = state?.quote?.PolicyAddons
	const rlData = state?.quote?.RiskLocations[0]

	const [CISData, setCISData] = useState(state?.quote?.CIS || {})
	const [proceedDisabled, setProceedDisabled] = useState(true)
	const handleCISData = (val, key) => {
		let prevValues = { ...CISData }
		prevValues[key] = val
		setCISData(prevValues)
	}

	const proceed = async () => {
		await new Promise((resolve, reject) => {
			dispatch({
				type: 'SET_CIS_DATA',
				data: {
					CIS: CISData,
				},
			})
			resolve()
		})

		await fetch.saveQuote()

		if (PolicyAddons?.CIT?.Present) {
			history.push('/cit')
		} else {
			history.push('/summary')
		}
	}

	const back = () => {
		history.goBack()
	}

	useEffect(() => {
		if (
			CISData?.Amount &&
			typeof CISData?.IsSafeLocked === 'boolean' &&
			CISData?.SafeDetails &&
			typeof CISData?.IsCCTVPresent === 'boolean' &&
			CISData?.Address
		) {
			setProceedDisabled(false)
		} else {
			setProceedDisabled(true)
		}
	}, [CISData])

	return (
		<Container>
			<MainContainer
				header="Enter Details"
				divider={true}
				rightOnClick={proceed}
				rightDisabled={proceedDisabled}
				leftOnClick={back}
				top={1}
			>
				<Header img={cisImg} header="Cash in Safe" />
				<Label compulsory>Amount to be insured</Label>
				<FormInput
					placeholder="Enter here"
					style={inputStyle}
					onChange={e => handleCISData(e.target.value, 'Amount')}
					value={CISData?.Amount}
					compulsory
					autoComma
					rupee
				/>
				<Space y={1.5} />
				<Label compulsory>Is the safe fully locked/secured?</Label>
				<div className="d-flex">
					<Radio
						className="flex-fill"
						text="Yes"
						secondary={true}
						value={CISData?.IsSafeLocked === true}
						onClick={() => handleCISData(true, 'IsSafeLocked')}
						textStyle={radioOptionTextStyle}
					/>
					<Radio
						className="flex-fill"
						text="No"
						secondary={true}
						value={CISData?.IsSafeLocked === false}
						onClick={() => handleCISData(false, 'IsSafeLocked')}
						textStyle={radioOptionTextStyle}
					/>
				</div>
				<Space y={1.5} />
				<Label compulsory>Make / Brand / Type of safe</Label>
				<FormInput
					placeholder="Eg: Godrej, Valencia, Amazon Basics"
					value={CISData?.SafeDetails}
					onChange={e => handleCISData(e.target.value, 'SafeDetails')}
					compulsory
					style={inputStyle}
				/>
				<Space y={1.5} />
				<Label compulsory>Is a CCTV present at the location?</Label>
				<div className="d-flex">
					<Radio
						className="flex-fill"
						text="Yes"
						secondary={true}
						value={CISData?.IsCCTVPresent === true}
						onClick={() => handleCISData(true, 'IsCCTVPresent')}
						textStyle={radioOptionTextStyle}
					/>
					<Radio
						className="flex-fill"
						text="No"
						secondary={true}
						value={CISData?.IsCCTVPresent === false}
						onClick={() => handleCISData(false, 'IsCCTVPresent')}
						textStyle={radioOptionTextStyle}
					/>
				</div>
				{CISData?.IsCCTVPresent === false ? CCTVWarning : null}
				{/* disabled is true if CIC is present */}
				<AddressField
					type="safe"
					value={CISData?.Address}
					handleUpdate={handleCISData}
					rlData={rlData}
				/>
			</MainContainer>
		</Container>
	)
}

export default CIS
